import React from 'react';
import { BrowserRouter as Router, Routes, Route/*, Navigate*/ } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import HomePage from './components/HomePage';
// import Dashboard from './components/Dashboard';
import Restart from './components/Restablecer';
import Principal from './components/Principal';


import { createTheme, ThemeProvider } from '@mui/material/styles';
import { purple } from '@mui/material/colors';

// Crear el tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: purple[500],  // Color principal
    },
    secondary: {
      main: '#f44336',    // Color secundario
    },
  },
});

function App() {
  // const isAuthenticated = !!localStorage.getItem('authToken');

  return (
    <ThemeProvider theme={theme}>
      <Router basename="/comerbas">
      {/* <Router> */}
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/dashboard" element={<Principal />}/>
          <Route path="/recuperar" element={<Restart />}/>          
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
